// extracted by mini-css-extract-plugin
export default {"products_main":"products_products_main__O6pl4"};